import { Link } from "react-router";
import { parseCollectionVersionRef } from "../../../shared/references/contentReferences";
import { appPaths } from "../../../shared/routing/appPaths";
import { useContentVersionName } from "./useContentVersionName";
import { useProjects } from "../../../projects/projectContext";

/** F77: model versions use their release number, or their commit date before release. */
export default function ContentVersionName({ projectId, reference: requested }: { projectId: string; reference: string }) {
  const { name, reference } = useContentVersionName(projectId, requested);
  const { selectProject } = useProjects();
  const exact = parseCollectionVersionRef(reference ?? "");
  return exact === null ? <span title={requested}>{name}</span> : <Link to={appPaths.ontology({ version: exact.commit })} onClick={() => { selectProject(projectId); }} title={reference ?? requested} className="app-link underline">{name}</Link>;
}
